import Default from "../Pages/Dashboard/Default/Default";
import Food from "../Pages/Food/Food";
import AllFoodOrder from "../Pages/Application/Master/book_ticket/AllFoodOrder";
import AccountSettings from "../Pages/SamplePage/AccountSettings";
import AccountProfile from "../Pages/SamplePage/AccountProfile";
import PrintFoodOrder from "../Pages/Application/Master/book_ticket/PrintFoodOrder";


const foodCRoutes = [
  // dashboard
  { path: `${process.env.PUBLIC_URL}/dashboard/default`, Component: <Default /> },
 // Account
   { path: `${process.env.PUBLIC_URL}/account/account_settings`, Component: <AccountSettings /> },
   { path: `${process.env.PUBLIC_URL}/account/account_profile`, Component: <AccountProfile /> },
 
  // Food
   { path: `${process.env.PUBLIC_URL}/food/food_order`, Component: <Food/> },
   { path: `${process.env.PUBLIC_URL}/food/all_food_order`, Component: <AllFoodOrder/> },
   { path: `${process.env.PUBLIC_URL}/print-food-order/:id`, Component: <PrintFoodOrder /> },
];

export default foodCRoutes;
